import { render } from "./DestinationIndex.vue?vue&type=template&id=685453a8"
import script from "./DestinationIndex.vue?vue&type=script&lang=js"
export * from "./DestinationIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__